/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WaitingRouteImport } from './routes/waiting'
import { Route as UpcomingRouteImport } from './routes/upcoming'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ReviewRouteImport } from './routes/review'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as AppsRouteImport } from './routes/apps'
import { Route as AllRouteImport } from './routes/all'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TasksIndexRouteImport } from './routes/tasks/index'
import { Route as ProjectsIndexRouteImport } from './routes/projects/index'
import { Route as PeopleIndexRouteImport } from './routes/people/index'
import { Route as HealthIndexRouteImport } from './routes/health/index'
import { Route as FinanceIndexRouteImport } from './routes/finance/index'
import { Route as AreasIndexRouteImport } from './routes/areas/index'
import { Route as TasksWaitingRouteImport } from './routes/tasks/waiting'
import { Route as TasksUpcomingRouteImport } from './routes/tasks/upcoming'
import { Route as TasksSuggestionsRouteImport } from './routes/tasks/suggestions'
import { Route as TasksReviewRouteImport } from './routes/tasks/review'
import { Route as TasksPomodoroRouteImport } from './routes/tasks/pomodoro'
import { Route as TasksInboxRouteImport } from './routes/tasks/inbox'
import { Route as TasksCalendarRouteImport } from './routes/tasks/calendar'
import { Route as TasksAllRouteImport } from './routes/tasks/all'
import { Route as TasksIdRouteImport } from './routes/tasks/$id'
import { Route as SettingsTodosRouteImport } from './routes/settings/todos'
import { Route as SettingsTasksRouteImport } from './routes/settings/tasks'
import { Route as SettingsProfileRouteImport } from './routes/settings/profile'
import { Route as SettingsAppearanceRouteImport } from './routes/settings/appearance'
import { Route as SettingsAgentsRouteImport } from './routes/settings/agents'
import { Route as ProjectsIdRouteImport } from './routes/projects/$id'
import { Route as PeopleIdRouteImport } from './routes/people/$id'
import { Route as HealthWorkoutsRouteImport } from './routes/health/workouts'
import { Route as HealthSleepRouteImport } from './routes/health/sleep'
import { Route as HealthReportsRouteImport } from './routes/health/reports'
import { Route as HealthProfileRouteImport } from './routes/health/profile'
import { Route as HealthPhasesRouteImport } from './routes/health/phases'
import { Route as HealthNutritionRouteImport } from './routes/health/nutrition'
import { Route as HealthMeasurementsRouteImport } from './routes/health/measurements'
import { Route as HealthGoalsRouteImport } from './routes/health/goals'
import { Route as HealthExercisesRouteImport } from './routes/health/exercises'
import { Route as HealthDataLoadsRouteImport } from './routes/health/data-loads'
import { Route as HealthCheckinRouteImport } from './routes/health/checkin'
import { Route as FinanceTransfersRouteImport } from './routes/finance/transfers'
import { Route as FinanceTransactionsRouteImport } from './routes/finance/transactions'
import { Route as FinanceSettingsRouteImport } from './routes/finance/settings'
import { Route as FinanceRulesRouteImport } from './routes/finance/rules'
import { Route as FinanceReviewRouteImport } from './routes/finance/review'
import { Route as FinanceReportsRouteImport } from './routes/finance/reports'
import { Route as FinanceImportRouteImport } from './routes/finance/import'
import { Route as FinanceCategoriesRouteImport } from './routes/finance/categories'
import { Route as FinanceBudgetsRouteImport } from './routes/finance/budgets'
import { Route as FinanceAccountsRouteImport } from './routes/finance/accounts'
import { Route as AreasIdRouteImport } from './routes/areas/$id'
import { Route as TasksProjectsIndexRouteImport } from './routes/tasks/projects/index'
import { Route as TasksPeopleIndexRouteImport } from './routes/tasks/people/index'
import { Route as TasksAreasIndexRouteImport } from './routes/tasks/areas/index'
import { Route as TasksProjectsIdRouteImport } from './routes/tasks/projects/$id'
import { Route as TasksPeopleIdRouteImport } from './routes/tasks/people/$id'
import { Route as TasksItemIdRouteImport } from './routes/tasks/item/$id'
import { Route as TasksAreasIdRouteImport } from './routes/tasks/areas/$id'
import { Route as SettingsPlatformApprovalsRouteImport } from './routes/settings/platform.approvals'
import { Route as SettingsPlatformAgentsRouteImport } from './routes/settings/platform.agents'

const WaitingRoute = WaitingRouteImport.update({
  id: '/waiting',
  path: '/waiting',
  getParentRoute: () => rootRouteImport,
} as any)
const UpcomingRoute = UpcomingRouteImport.update({
  id: '/upcoming',
  path: '/upcoming',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewRoute = ReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsRoute = AppsRouteImport.update({
  id: '/apps',
  path: '/apps',
  getParentRoute: () => rootRouteImport,
} as any)
const AllRoute = AllRouteImport.update({
  id: '/all',
  path: '/all',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksIndexRoute = TasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleIndexRoute = PeopleIndexRouteImport.update({
  id: '/people/',
  path: '/people/',
  getParentRoute: () => rootRouteImport,
} as any)
const HealthIndexRoute = HealthIndexRouteImport.update({
  id: '/health/',
  path: '/health/',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceIndexRoute = FinanceIndexRouteImport.update({
  id: '/finance/',
  path: '/finance/',
  getParentRoute: () => rootRouteImport,
} as any)
const AreasIndexRoute = AreasIndexRouteImport.update({
  id: '/areas/',
  path: '/areas/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksWaitingRoute = TasksWaitingRouteImport.update({
  id: '/tasks/waiting',
  path: '/tasks/waiting',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksUpcomingRoute = TasksUpcomingRouteImport.update({
  id: '/tasks/upcoming',
  path: '/tasks/upcoming',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksSuggestionsRoute = TasksSuggestionsRouteImport.update({
  id: '/tasks/suggestions',
  path: '/tasks/suggestions',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksReviewRoute = TasksReviewRouteImport.update({
  id: '/tasks/review',
  path: '/tasks/review',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksPomodoroRoute = TasksPomodoroRouteImport.update({
  id: '/tasks/pomodoro',
  path: '/tasks/pomodoro',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksInboxRoute = TasksInboxRouteImport.update({
  id: '/tasks/inbox',
  path: '/tasks/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksCalendarRoute = TasksCalendarRouteImport.update({
  id: '/tasks/calendar',
  path: '/tasks/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksAllRoute = TasksAllRouteImport.update({
  id: '/tasks/all',
  path: '/tasks/all',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksIdRoute = TasksIdRouteImport.update({
  id: '/tasks/$id',
  path: '/tasks/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsTodosRoute = SettingsTodosRouteImport.update({
  id: '/todos',
  path: '/todos',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsTasksRoute = SettingsTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsProfileRoute = SettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAppearanceRoute = SettingsAppearanceRouteImport.update({
  id: '/appearance',
  path: '/appearance',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAgentsRoute = SettingsAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => SettingsRoute,
} as any)
const ProjectsIdRoute = ProjectsIdRouteImport.update({
  id: '/projects/$id',
  path: '/projects/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleIdRoute = PeopleIdRouteImport.update({
  id: '/people/$id',
  path: '/people/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const HealthWorkoutsRoute = HealthWorkoutsRouteImport.update({
  id: '/health/workouts',
  path: '/health/workouts',
  getParentRoute: () => rootRouteImport,
} as any)
const HealthSleepRoute = HealthSleepRouteImport.update({
  id: '/health/sleep',
  path: '/health/sleep',
  getParentRoute: () => rootRouteImport,
} as any)
const HealthReportsRoute = HealthReportsRouteImport.update({
  id: '/health/reports',
  path: '/health/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const HealthProfileRoute = HealthProfileRouteImport.update({
  id: '/health/profile',
  path: '/health/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const HealthPhasesRoute = HealthPhasesRouteImport.update({
  id: '/health/phases',
  path: '/health/phases',
  getParentRoute: () => rootRouteImport,
} as any)
const HealthNutritionRoute = HealthNutritionRouteImport.update({
  id: '/health/nutrition',
  path: '/health/nutrition',
  getParentRoute: () => rootRouteImport,
} as any)
const HealthMeasurementsRoute = HealthMeasurementsRouteImport.update({
  id: '/health/measurements',
  path: '/health/measurements',
  getParentRoute: () => rootRouteImport,
} as any)
const HealthGoalsRoute = HealthGoalsRouteImport.update({
  id: '/health/goals',
  path: '/health/goals',
  getParentRoute: () => rootRouteImport,
} as any)
const HealthExercisesRoute = HealthExercisesRouteImport.update({
  id: '/health/exercises',
  path: '/health/exercises',
  getParentRoute: () => rootRouteImport,
} as any)
const HealthDataLoadsRoute = HealthDataLoadsRouteImport.update({
  id: '/health/data-loads',
  path: '/health/data-loads',
  getParentRoute: () => rootRouteImport,
} as any)
const HealthCheckinRoute = HealthCheckinRouteImport.update({
  id: '/health/checkin',
  path: '/health/checkin',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceTransfersRoute = FinanceTransfersRouteImport.update({
  id: '/finance/transfers',
  path: '/finance/transfers',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceTransactionsRoute = FinanceTransactionsRouteImport.update({
  id: '/finance/transactions',
  path: '/finance/transactions',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceSettingsRoute = FinanceSettingsRouteImport.update({
  id: '/finance/settings',
  path: '/finance/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceRulesRoute = FinanceRulesRouteImport.update({
  id: '/finance/rules',
  path: '/finance/rules',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceReviewRoute = FinanceReviewRouteImport.update({
  id: '/finance/review',
  path: '/finance/review',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceReportsRoute = FinanceReportsRouteImport.update({
  id: '/finance/reports',
  path: '/finance/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceImportRoute = FinanceImportRouteImport.update({
  id: '/finance/import',
  path: '/finance/import',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceCategoriesRoute = FinanceCategoriesRouteImport.update({
  id: '/finance/categories',
  path: '/finance/categories',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceBudgetsRoute = FinanceBudgetsRouteImport.update({
  id: '/finance/budgets',
  path: '/finance/budgets',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceAccountsRoute = FinanceAccountsRouteImport.update({
  id: '/finance/accounts',
  path: '/finance/accounts',
  getParentRoute: () => rootRouteImport,
} as any)
const AreasIdRoute = AreasIdRouteImport.update({
  id: '/areas/$id',
  path: '/areas/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksProjectsIndexRoute = TasksProjectsIndexRouteImport.update({
  id: '/tasks/projects/',
  path: '/tasks/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksPeopleIndexRoute = TasksPeopleIndexRouteImport.update({
  id: '/tasks/people/',
  path: '/tasks/people/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksAreasIndexRoute = TasksAreasIndexRouteImport.update({
  id: '/tasks/areas/',
  path: '/tasks/areas/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksProjectsIdRoute = TasksProjectsIdRouteImport.update({
  id: '/tasks/projects/$id',
  path: '/tasks/projects/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksPeopleIdRoute = TasksPeopleIdRouteImport.update({
  id: '/tasks/people/$id',
  path: '/tasks/people/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksItemIdRoute = TasksItemIdRouteImport.update({
  id: '/tasks/item/$id',
  path: '/tasks/item/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksAreasIdRoute = TasksAreasIdRouteImport.update({
  id: '/tasks/areas/$id',
  path: '/tasks/areas/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsPlatformApprovalsRoute =
  SettingsPlatformApprovalsRouteImport.update({
    id: '/platform/approvals',
    path: '/platform/approvals',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsPlatformAgentsRoute = SettingsPlatformAgentsRouteImport.update({
  id: '/platform/agents',
  path: '/platform/agents',
  getParentRoute: () => SettingsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/all': typeof AllRoute
  '/apps': typeof AppsRoute
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/review': typeof ReviewRoute
  '/settings': typeof SettingsRouteWithChildren
  '/signup': typeof SignupRoute
  '/upcoming': typeof UpcomingRoute
  '/waiting': typeof WaitingRoute
  '/areas/$id': typeof AreasIdRoute
  '/finance/accounts': typeof FinanceAccountsRoute
  '/finance/budgets': typeof FinanceBudgetsRoute
  '/finance/categories': typeof FinanceCategoriesRoute
  '/finance/import': typeof FinanceImportRoute
  '/finance/reports': typeof FinanceReportsRoute
  '/finance/review': typeof FinanceReviewRoute
  '/finance/rules': typeof FinanceRulesRoute
  '/finance/settings': typeof FinanceSettingsRoute
  '/finance/transactions': typeof FinanceTransactionsRoute
  '/finance/transfers': typeof FinanceTransfersRoute
  '/health/checkin': typeof HealthCheckinRoute
  '/health/data-loads': typeof HealthDataLoadsRoute
  '/health/exercises': typeof HealthExercisesRoute
  '/health/goals': typeof HealthGoalsRoute
  '/health/measurements': typeof HealthMeasurementsRoute
  '/health/nutrition': typeof HealthNutritionRoute
  '/health/phases': typeof HealthPhasesRoute
  '/health/profile': typeof HealthProfileRoute
  '/health/reports': typeof HealthReportsRoute
  '/health/sleep': typeof HealthSleepRoute
  '/health/workouts': typeof HealthWorkoutsRoute
  '/people/$id': typeof PeopleIdRoute
  '/projects/$id': typeof ProjectsIdRoute
  '/settings/agents': typeof SettingsAgentsRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/tasks': typeof SettingsTasksRoute
  '/settings/todos': typeof SettingsTodosRoute
  '/tasks/$id': typeof TasksIdRoute
  '/tasks/all': typeof TasksAllRoute
  '/tasks/calendar': typeof TasksCalendarRoute
  '/tasks/inbox': typeof TasksInboxRoute
  '/tasks/pomodoro': typeof TasksPomodoroRoute
  '/tasks/review': typeof TasksReviewRoute
  '/tasks/suggestions': typeof TasksSuggestionsRoute
  '/tasks/upcoming': typeof TasksUpcomingRoute
  '/tasks/waiting': typeof TasksWaitingRoute
  '/areas/': typeof AreasIndexRoute
  '/finance/': typeof FinanceIndexRoute
  '/health/': typeof HealthIndexRoute
  '/people/': typeof PeopleIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/tasks/': typeof TasksIndexRoute
  '/settings/platform/agents': typeof SettingsPlatformAgentsRoute
  '/settings/platform/approvals': typeof SettingsPlatformApprovalsRoute
  '/tasks/areas/$id': typeof TasksAreasIdRoute
  '/tasks/item/$id': typeof TasksItemIdRoute
  '/tasks/people/$id': typeof TasksPeopleIdRoute
  '/tasks/projects/$id': typeof TasksProjectsIdRoute
  '/tasks/areas/': typeof TasksAreasIndexRoute
  '/tasks/people/': typeof TasksPeopleIndexRoute
  '/tasks/projects/': typeof TasksProjectsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/all': typeof AllRoute
  '/apps': typeof AppsRoute
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/review': typeof ReviewRoute
  '/settings': typeof SettingsRouteWithChildren
  '/signup': typeof SignupRoute
  '/upcoming': typeof UpcomingRoute
  '/waiting': typeof WaitingRoute
  '/areas/$id': typeof AreasIdRoute
  '/finance/accounts': typeof FinanceAccountsRoute
  '/finance/budgets': typeof FinanceBudgetsRoute
  '/finance/categories': typeof FinanceCategoriesRoute
  '/finance/import': typeof FinanceImportRoute
  '/finance/reports': typeof FinanceReportsRoute
  '/finance/review': typeof FinanceReviewRoute
  '/finance/rules': typeof FinanceRulesRoute
  '/finance/settings': typeof FinanceSettingsRoute
  '/finance/transactions': typeof FinanceTransactionsRoute
  '/finance/transfers': typeof FinanceTransfersRoute
  '/health/checkin': typeof HealthCheckinRoute
  '/health/data-loads': typeof HealthDataLoadsRoute
  '/health/exercises': typeof HealthExercisesRoute
  '/health/goals': typeof HealthGoalsRoute
  '/health/measurements': typeof HealthMeasurementsRoute
  '/health/nutrition': typeof HealthNutritionRoute
  '/health/phases': typeof HealthPhasesRoute
  '/health/profile': typeof HealthProfileRoute
  '/health/reports': typeof HealthReportsRoute
  '/health/sleep': typeof HealthSleepRoute
  '/health/workouts': typeof HealthWorkoutsRoute
  '/people/$id': typeof PeopleIdRoute
  '/projects/$id': typeof ProjectsIdRoute
  '/settings/agents': typeof SettingsAgentsRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/tasks': typeof SettingsTasksRoute
  '/settings/todos': typeof SettingsTodosRoute
  '/tasks/$id': typeof TasksIdRoute
  '/tasks/all': typeof TasksAllRoute
  '/tasks/calendar': typeof TasksCalendarRoute
  '/tasks/inbox': typeof TasksInboxRoute
  '/tasks/pomodoro': typeof TasksPomodoroRoute
  '/tasks/review': typeof TasksReviewRoute
  '/tasks/suggestions': typeof TasksSuggestionsRoute
  '/tasks/upcoming': typeof TasksUpcomingRoute
  '/tasks/waiting': typeof TasksWaitingRoute
  '/areas': typeof AreasIndexRoute
  '/finance': typeof FinanceIndexRoute
  '/health': typeof HealthIndexRoute
  '/people': typeof PeopleIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/tasks': typeof TasksIndexRoute
  '/settings/platform/agents': typeof SettingsPlatformAgentsRoute
  '/settings/platform/approvals': typeof SettingsPlatformApprovalsRoute
  '/tasks/areas/$id': typeof TasksAreasIdRoute
  '/tasks/item/$id': typeof TasksItemIdRoute
  '/tasks/people/$id': typeof TasksPeopleIdRoute
  '/tasks/projects/$id': typeof TasksProjectsIdRoute
  '/tasks/areas': typeof TasksAreasIndexRoute
  '/tasks/people': typeof TasksPeopleIndexRoute
  '/tasks/projects': typeof TasksProjectsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/all': typeof AllRoute
  '/apps': typeof AppsRoute
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/review': typeof ReviewRoute
  '/settings': typeof SettingsRouteWithChildren
  '/signup': typeof SignupRoute
  '/upcoming': typeof UpcomingRoute
  '/waiting': typeof WaitingRoute
  '/areas/$id': typeof AreasIdRoute
  '/finance/accounts': typeof FinanceAccountsRoute
  '/finance/budgets': typeof FinanceBudgetsRoute
  '/finance/categories': typeof FinanceCategoriesRoute
  '/finance/import': typeof FinanceImportRoute
  '/finance/reports': typeof FinanceReportsRoute
  '/finance/review': typeof FinanceReviewRoute
  '/finance/rules': typeof FinanceRulesRoute
  '/finance/settings': typeof FinanceSettingsRoute
  '/finance/transactions': typeof FinanceTransactionsRoute
  '/finance/transfers': typeof FinanceTransfersRoute
  '/health/checkin': typeof HealthCheckinRoute
  '/health/data-loads': typeof HealthDataLoadsRoute
  '/health/exercises': typeof HealthExercisesRoute
  '/health/goals': typeof HealthGoalsRoute
  '/health/measurements': typeof HealthMeasurementsRoute
  '/health/nutrition': typeof HealthNutritionRoute
  '/health/phases': typeof HealthPhasesRoute
  '/health/profile': typeof HealthProfileRoute
  '/health/reports': typeof HealthReportsRoute
  '/health/sleep': typeof HealthSleepRoute
  '/health/workouts': typeof HealthWorkoutsRoute
  '/people/$id': typeof PeopleIdRoute
  '/projects/$id': typeof ProjectsIdRoute
  '/settings/agents': typeof SettingsAgentsRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/tasks': typeof SettingsTasksRoute
  '/settings/todos': typeof SettingsTodosRoute
  '/tasks/$id': typeof TasksIdRoute
  '/tasks/all': typeof TasksAllRoute
  '/tasks/calendar': typeof TasksCalendarRoute
  '/tasks/inbox': typeof TasksInboxRoute
  '/tasks/pomodoro': typeof TasksPomodoroRoute
  '/tasks/review': typeof TasksReviewRoute
  '/tasks/suggestions': typeof TasksSuggestionsRoute
  '/tasks/upcoming': typeof TasksUpcomingRoute
  '/tasks/waiting': typeof TasksWaitingRoute
  '/areas/': typeof AreasIndexRoute
  '/finance/': typeof FinanceIndexRoute
  '/health/': typeof HealthIndexRoute
  '/people/': typeof PeopleIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/tasks/': typeof TasksIndexRoute
  '/settings/platform/agents': typeof SettingsPlatformAgentsRoute
  '/settings/platform/approvals': typeof SettingsPlatformApprovalsRoute
  '/tasks/areas/$id': typeof TasksAreasIdRoute
  '/tasks/item/$id': typeof TasksItemIdRoute
  '/tasks/people/$id': typeof TasksPeopleIdRoute
  '/tasks/projects/$id': typeof TasksProjectsIdRoute
  '/tasks/areas/': typeof TasksAreasIndexRoute
  '/tasks/people/': typeof TasksPeopleIndexRoute
  '/tasks/projects/': typeof TasksProjectsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/all'
    | '/apps'
    | '/inbox'
    | '/login'
    | '/review'
    | '/settings'
    | '/signup'
    | '/upcoming'
    | '/waiting'
    | '/areas/$id'
    | '/finance/accounts'
    | '/finance/budgets'
    | '/finance/categories'
    | '/finance/import'
    | '/finance/reports'
    | '/finance/review'
    | '/finance/rules'
    | '/finance/settings'
    | '/finance/transactions'
    | '/finance/transfers'
    | '/health/checkin'
    | '/health/data-loads'
    | '/health/exercises'
    | '/health/goals'
    | '/health/measurements'
    | '/health/nutrition'
    | '/health/phases'
    | '/health/profile'
    | '/health/reports'
    | '/health/sleep'
    | '/health/workouts'
    | '/people/$id'
    | '/projects/$id'
    | '/settings/agents'
    | '/settings/appearance'
    | '/settings/profile'
    | '/settings/tasks'
    | '/settings/todos'
    | '/tasks/$id'
    | '/tasks/all'
    | '/tasks/calendar'
    | '/tasks/inbox'
    | '/tasks/pomodoro'
    | '/tasks/review'
    | '/tasks/suggestions'
    | '/tasks/upcoming'
    | '/tasks/waiting'
    | '/areas/'
    | '/finance/'
    | '/health/'
    | '/people/'
    | '/projects/'
    | '/tasks/'
    | '/settings/platform/agents'
    | '/settings/platform/approvals'
    | '/tasks/areas/$id'
    | '/tasks/item/$id'
    | '/tasks/people/$id'
    | '/tasks/projects/$id'
    | '/tasks/areas/'
    | '/tasks/people/'
    | '/tasks/projects/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/all'
    | '/apps'
    | '/inbox'
    | '/login'
    | '/review'
    | '/settings'
    | '/signup'
    | '/upcoming'
    | '/waiting'
    | '/areas/$id'
    | '/finance/accounts'
    | '/finance/budgets'
    | '/finance/categories'
    | '/finance/import'
    | '/finance/reports'
    | '/finance/review'
    | '/finance/rules'
    | '/finance/settings'
    | '/finance/transactions'
    | '/finance/transfers'
    | '/health/checkin'
    | '/health/data-loads'
    | '/health/exercises'
    | '/health/goals'
    | '/health/measurements'
    | '/health/nutrition'
    | '/health/phases'
    | '/health/profile'
    | '/health/reports'
    | '/health/sleep'
    | '/health/workouts'
    | '/people/$id'
    | '/projects/$id'
    | '/settings/agents'
    | '/settings/appearance'
    | '/settings/profile'
    | '/settings/tasks'
    | '/settings/todos'
    | '/tasks/$id'
    | '/tasks/all'
    | '/tasks/calendar'
    | '/tasks/inbox'
    | '/tasks/pomodoro'
    | '/tasks/review'
    | '/tasks/suggestions'
    | '/tasks/upcoming'
    | '/tasks/waiting'
    | '/areas'
    | '/finance'
    | '/health'
    | '/people'
    | '/projects'
    | '/tasks'
    | '/settings/platform/agents'
    | '/settings/platform/approvals'
    | '/tasks/areas/$id'
    | '/tasks/item/$id'
    | '/tasks/people/$id'
    | '/tasks/projects/$id'
    | '/tasks/areas'
    | '/tasks/people'
    | '/tasks/projects'
  id:
    | '__root__'
    | '/'
    | '/all'
    | '/apps'
    | '/inbox'
    | '/login'
    | '/review'
    | '/settings'
    | '/signup'
    | '/upcoming'
    | '/waiting'
    | '/areas/$id'
    | '/finance/accounts'
    | '/finance/budgets'
    | '/finance/categories'
    | '/finance/import'
    | '/finance/reports'
    | '/finance/review'
    | '/finance/rules'
    | '/finance/settings'
    | '/finance/transactions'
    | '/finance/transfers'
    | '/health/checkin'
    | '/health/data-loads'
    | '/health/exercises'
    | '/health/goals'
    | '/health/measurements'
    | '/health/nutrition'
    | '/health/phases'
    | '/health/profile'
    | '/health/reports'
    | '/health/sleep'
    | '/health/workouts'
    | '/people/$id'
    | '/projects/$id'
    | '/settings/agents'
    | '/settings/appearance'
    | '/settings/profile'
    | '/settings/tasks'
    | '/settings/todos'
    | '/tasks/$id'
    | '/tasks/all'
    | '/tasks/calendar'
    | '/tasks/inbox'
    | '/tasks/pomodoro'
    | '/tasks/review'
    | '/tasks/suggestions'
    | '/tasks/upcoming'
    | '/tasks/waiting'
    | '/areas/'
    | '/finance/'
    | '/health/'
    | '/people/'
    | '/projects/'
    | '/tasks/'
    | '/settings/platform/agents'
    | '/settings/platform/approvals'
    | '/tasks/areas/$id'
    | '/tasks/item/$id'
    | '/tasks/people/$id'
    | '/tasks/projects/$id'
    | '/tasks/areas/'
    | '/tasks/people/'
    | '/tasks/projects/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AllRoute: typeof AllRoute
  AppsRoute: typeof AppsRoute
  InboxRoute: typeof InboxRoute
  LoginRoute: typeof LoginRoute
  ReviewRoute: typeof ReviewRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  SignupRoute: typeof SignupRoute
  UpcomingRoute: typeof UpcomingRoute
  WaitingRoute: typeof WaitingRoute
  AreasIdRoute: typeof AreasIdRoute
  FinanceAccountsRoute: typeof FinanceAccountsRoute
  FinanceBudgetsRoute: typeof FinanceBudgetsRoute
  FinanceCategoriesRoute: typeof FinanceCategoriesRoute
  FinanceImportRoute: typeof FinanceImportRoute
  FinanceReportsRoute: typeof FinanceReportsRoute
  FinanceReviewRoute: typeof FinanceReviewRoute
  FinanceRulesRoute: typeof FinanceRulesRoute
  FinanceSettingsRoute: typeof FinanceSettingsRoute
  FinanceTransactionsRoute: typeof FinanceTransactionsRoute
  FinanceTransfersRoute: typeof FinanceTransfersRoute
  HealthCheckinRoute: typeof HealthCheckinRoute
  HealthDataLoadsRoute: typeof HealthDataLoadsRoute
  HealthExercisesRoute: typeof HealthExercisesRoute
  HealthGoalsRoute: typeof HealthGoalsRoute
  HealthMeasurementsRoute: typeof HealthMeasurementsRoute
  HealthNutritionRoute: typeof HealthNutritionRoute
  HealthPhasesRoute: typeof HealthPhasesRoute
  HealthProfileRoute: typeof HealthProfileRoute
  HealthReportsRoute: typeof HealthReportsRoute
  HealthSleepRoute: typeof HealthSleepRoute
  HealthWorkoutsRoute: typeof HealthWorkoutsRoute
  PeopleIdRoute: typeof PeopleIdRoute
  ProjectsIdRoute: typeof ProjectsIdRoute
  TasksIdRoute: typeof TasksIdRoute
  TasksAllRoute: typeof TasksAllRoute
  TasksCalendarRoute: typeof TasksCalendarRoute
  TasksInboxRoute: typeof TasksInboxRoute
  TasksPomodoroRoute: typeof TasksPomodoroRoute
  TasksReviewRoute: typeof TasksReviewRoute
  TasksSuggestionsRoute: typeof TasksSuggestionsRoute
  TasksUpcomingRoute: typeof TasksUpcomingRoute
  TasksWaitingRoute: typeof TasksWaitingRoute
  AreasIndexRoute: typeof AreasIndexRoute
  FinanceIndexRoute: typeof FinanceIndexRoute
  HealthIndexRoute: typeof HealthIndexRoute
  PeopleIndexRoute: typeof PeopleIndexRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
  TasksIndexRoute: typeof TasksIndexRoute
  TasksAreasIdRoute: typeof TasksAreasIdRoute
  TasksItemIdRoute: typeof TasksItemIdRoute
  TasksPeopleIdRoute: typeof TasksPeopleIdRoute
  TasksProjectsIdRoute: typeof TasksProjectsIdRoute
  TasksAreasIndexRoute: typeof TasksAreasIndexRoute
  TasksPeopleIndexRoute: typeof TasksPeopleIndexRoute
  TasksProjectsIndexRoute: typeof TasksProjectsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/waiting': {
      id: '/waiting'
      path: '/waiting'
      fullPath: '/waiting'
      preLoaderRoute: typeof WaitingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upcoming': {
      id: '/upcoming'
      path: '/upcoming'
      fullPath: '/upcoming'
      preLoaderRoute: typeof UpcomingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/review': {
      id: '/review'
      path: '/review'
      fullPath: '/review'
      preLoaderRoute: typeof ReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps': {
      id: '/apps'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof AppsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/all': {
      id: '/all'
      path: '/all'
      fullPath: '/all'
      preLoaderRoute: typeof AllRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/': {
      id: '/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof TasksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/': {
      id: '/people/'
      path: '/people'
      fullPath: '/people/'
      preLoaderRoute: typeof PeopleIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/health/': {
      id: '/health/'
      path: '/health'
      fullPath: '/health/'
      preLoaderRoute: typeof HealthIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance/': {
      id: '/finance/'
      path: '/finance'
      fullPath: '/finance/'
      preLoaderRoute: typeof FinanceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/areas/': {
      id: '/areas/'
      path: '/areas'
      fullPath: '/areas/'
      preLoaderRoute: typeof AreasIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/waiting': {
      id: '/tasks/waiting'
      path: '/tasks/waiting'
      fullPath: '/tasks/waiting'
      preLoaderRoute: typeof TasksWaitingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/upcoming': {
      id: '/tasks/upcoming'
      path: '/tasks/upcoming'
      fullPath: '/tasks/upcoming'
      preLoaderRoute: typeof TasksUpcomingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/suggestions': {
      id: '/tasks/suggestions'
      path: '/tasks/suggestions'
      fullPath: '/tasks/suggestions'
      preLoaderRoute: typeof TasksSuggestionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/review': {
      id: '/tasks/review'
      path: '/tasks/review'
      fullPath: '/tasks/review'
      preLoaderRoute: typeof TasksReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/pomodoro': {
      id: '/tasks/pomodoro'
      path: '/tasks/pomodoro'
      fullPath: '/tasks/pomodoro'
      preLoaderRoute: typeof TasksPomodoroRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/inbox': {
      id: '/tasks/inbox'
      path: '/tasks/inbox'
      fullPath: '/tasks/inbox'
      preLoaderRoute: typeof TasksInboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/calendar': {
      id: '/tasks/calendar'
      path: '/tasks/calendar'
      fullPath: '/tasks/calendar'
      preLoaderRoute: typeof TasksCalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/all': {
      id: '/tasks/all'
      path: '/tasks/all'
      fullPath: '/tasks/all'
      preLoaderRoute: typeof TasksAllRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/$id': {
      id: '/tasks/$id'
      path: '/tasks/$id'
      fullPath: '/tasks/$id'
      preLoaderRoute: typeof TasksIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/todos': {
      id: '/settings/todos'
      path: '/todos'
      fullPath: '/settings/todos'
      preLoaderRoute: typeof SettingsTodosRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/tasks': {
      id: '/settings/tasks'
      path: '/tasks'
      fullPath: '/settings/tasks'
      preLoaderRoute: typeof SettingsTasksRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/profile': {
      id: '/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof SettingsProfileRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/appearance': {
      id: '/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof SettingsAppearanceRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/agents': {
      id: '/settings/agents'
      path: '/agents'
      fullPath: '/settings/agents'
      preLoaderRoute: typeof SettingsAgentsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/projects/$id': {
      id: '/projects/$id'
      path: '/projects/$id'
      fullPath: '/projects/$id'
      preLoaderRoute: typeof ProjectsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/$id': {
      id: '/people/$id'
      path: '/people/$id'
      fullPath: '/people/$id'
      preLoaderRoute: typeof PeopleIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/health/workouts': {
      id: '/health/workouts'
      path: '/health/workouts'
      fullPath: '/health/workouts'
      preLoaderRoute: typeof HealthWorkoutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/health/sleep': {
      id: '/health/sleep'
      path: '/health/sleep'
      fullPath: '/health/sleep'
      preLoaderRoute: typeof HealthSleepRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/health/reports': {
      id: '/health/reports'
      path: '/health/reports'
      fullPath: '/health/reports'
      preLoaderRoute: typeof HealthReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/health/profile': {
      id: '/health/profile'
      path: '/health/profile'
      fullPath: '/health/profile'
      preLoaderRoute: typeof HealthProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/health/phases': {
      id: '/health/phases'
      path: '/health/phases'
      fullPath: '/health/phases'
      preLoaderRoute: typeof HealthPhasesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/health/nutrition': {
      id: '/health/nutrition'
      path: '/health/nutrition'
      fullPath: '/health/nutrition'
      preLoaderRoute: typeof HealthNutritionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/health/measurements': {
      id: '/health/measurements'
      path: '/health/measurements'
      fullPath: '/health/measurements'
      preLoaderRoute: typeof HealthMeasurementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/health/goals': {
      id: '/health/goals'
      path: '/health/goals'
      fullPath: '/health/goals'
      preLoaderRoute: typeof HealthGoalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/health/exercises': {
      id: '/health/exercises'
      path: '/health/exercises'
      fullPath: '/health/exercises'
      preLoaderRoute: typeof HealthExercisesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/health/data-loads': {
      id: '/health/data-loads'
      path: '/health/data-loads'
      fullPath: '/health/data-loads'
      preLoaderRoute: typeof HealthDataLoadsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/health/checkin': {
      id: '/health/checkin'
      path: '/health/checkin'
      fullPath: '/health/checkin'
      preLoaderRoute: typeof HealthCheckinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance/transfers': {
      id: '/finance/transfers'
      path: '/finance/transfers'
      fullPath: '/finance/transfers'
      preLoaderRoute: typeof FinanceTransfersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance/transactions': {
      id: '/finance/transactions'
      path: '/finance/transactions'
      fullPath: '/finance/transactions'
      preLoaderRoute: typeof FinanceTransactionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance/settings': {
      id: '/finance/settings'
      path: '/finance/settings'
      fullPath: '/finance/settings'
      preLoaderRoute: typeof FinanceSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance/rules': {
      id: '/finance/rules'
      path: '/finance/rules'
      fullPath: '/finance/rules'
      preLoaderRoute: typeof FinanceRulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance/review': {
      id: '/finance/review'
      path: '/finance/review'
      fullPath: '/finance/review'
      preLoaderRoute: typeof FinanceReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance/reports': {
      id: '/finance/reports'
      path: '/finance/reports'
      fullPath: '/finance/reports'
      preLoaderRoute: typeof FinanceReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance/import': {
      id: '/finance/import'
      path: '/finance/import'
      fullPath: '/finance/import'
      preLoaderRoute: typeof FinanceImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance/categories': {
      id: '/finance/categories'
      path: '/finance/categories'
      fullPath: '/finance/categories'
      preLoaderRoute: typeof FinanceCategoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance/budgets': {
      id: '/finance/budgets'
      path: '/finance/budgets'
      fullPath: '/finance/budgets'
      preLoaderRoute: typeof FinanceBudgetsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance/accounts': {
      id: '/finance/accounts'
      path: '/finance/accounts'
      fullPath: '/finance/accounts'
      preLoaderRoute: typeof FinanceAccountsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/areas/$id': {
      id: '/areas/$id'
      path: '/areas/$id'
      fullPath: '/areas/$id'
      preLoaderRoute: typeof AreasIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/projects/': {
      id: '/tasks/projects/'
      path: '/tasks/projects'
      fullPath: '/tasks/projects/'
      preLoaderRoute: typeof TasksProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/people/': {
      id: '/tasks/people/'
      path: '/tasks/people'
      fullPath: '/tasks/people/'
      preLoaderRoute: typeof TasksPeopleIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/areas/': {
      id: '/tasks/areas/'
      path: '/tasks/areas'
      fullPath: '/tasks/areas/'
      preLoaderRoute: typeof TasksAreasIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/projects/$id': {
      id: '/tasks/projects/$id'
      path: '/tasks/projects/$id'
      fullPath: '/tasks/projects/$id'
      preLoaderRoute: typeof TasksProjectsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/people/$id': {
      id: '/tasks/people/$id'
      path: '/tasks/people/$id'
      fullPath: '/tasks/people/$id'
      preLoaderRoute: typeof TasksPeopleIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/item/$id': {
      id: '/tasks/item/$id'
      path: '/tasks/item/$id'
      fullPath: '/tasks/item/$id'
      preLoaderRoute: typeof TasksItemIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/areas/$id': {
      id: '/tasks/areas/$id'
      path: '/tasks/areas/$id'
      fullPath: '/tasks/areas/$id'
      preLoaderRoute: typeof TasksAreasIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/platform/approvals': {
      id: '/settings/platform/approvals'
      path: '/platform/approvals'
      fullPath: '/settings/platform/approvals'
      preLoaderRoute: typeof SettingsPlatformApprovalsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/platform/agents': {
      id: '/settings/platform/agents'
      path: '/platform/agents'
      fullPath: '/settings/platform/agents'
      preLoaderRoute: typeof SettingsPlatformAgentsRouteImport
      parentRoute: typeof SettingsRoute
    }
  }
}

interface SettingsRouteChildren {
  SettingsAgentsRoute: typeof SettingsAgentsRoute
  SettingsAppearanceRoute: typeof SettingsAppearanceRoute
  SettingsProfileRoute: typeof SettingsProfileRoute
  SettingsTasksRoute: typeof SettingsTasksRoute
  SettingsTodosRoute: typeof SettingsTodosRoute
  SettingsPlatformAgentsRoute: typeof SettingsPlatformAgentsRoute
  SettingsPlatformApprovalsRoute: typeof SettingsPlatformApprovalsRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsAgentsRoute: SettingsAgentsRoute,
  SettingsAppearanceRoute: SettingsAppearanceRoute,
  SettingsProfileRoute: SettingsProfileRoute,
  SettingsTasksRoute: SettingsTasksRoute,
  SettingsTodosRoute: SettingsTodosRoute,
  SettingsPlatformAgentsRoute: SettingsPlatformAgentsRoute,
  SettingsPlatformApprovalsRoute: SettingsPlatformApprovalsRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AllRoute: AllRoute,
  AppsRoute: AppsRoute,
  InboxRoute: InboxRoute,
  LoginRoute: LoginRoute,
  ReviewRoute: ReviewRoute,
  SettingsRoute: SettingsRouteWithChildren,
  SignupRoute: SignupRoute,
  UpcomingRoute: UpcomingRoute,
  WaitingRoute: WaitingRoute,
  AreasIdRoute: AreasIdRoute,
  FinanceAccountsRoute: FinanceAccountsRoute,
  FinanceBudgetsRoute: FinanceBudgetsRoute,
  FinanceCategoriesRoute: FinanceCategoriesRoute,
  FinanceImportRoute: FinanceImportRoute,
  FinanceReportsRoute: FinanceReportsRoute,
  FinanceReviewRoute: FinanceReviewRoute,
  FinanceRulesRoute: FinanceRulesRoute,
  FinanceSettingsRoute: FinanceSettingsRoute,
  FinanceTransactionsRoute: FinanceTransactionsRoute,
  FinanceTransfersRoute: FinanceTransfersRoute,
  HealthCheckinRoute: HealthCheckinRoute,
  HealthDataLoadsRoute: HealthDataLoadsRoute,
  HealthExercisesRoute: HealthExercisesRoute,
  HealthGoalsRoute: HealthGoalsRoute,
  HealthMeasurementsRoute: HealthMeasurementsRoute,
  HealthNutritionRoute: HealthNutritionRoute,
  HealthPhasesRoute: HealthPhasesRoute,
  HealthProfileRoute: HealthProfileRoute,
  HealthReportsRoute: HealthReportsRoute,
  HealthSleepRoute: HealthSleepRoute,
  HealthWorkoutsRoute: HealthWorkoutsRoute,
  PeopleIdRoute: PeopleIdRoute,
  ProjectsIdRoute: ProjectsIdRoute,
  TasksIdRoute: TasksIdRoute,
  TasksAllRoute: TasksAllRoute,
  TasksCalendarRoute: TasksCalendarRoute,
  TasksInboxRoute: TasksInboxRoute,
  TasksPomodoroRoute: TasksPomodoroRoute,
  TasksReviewRoute: TasksReviewRoute,
  TasksSuggestionsRoute: TasksSuggestionsRoute,
  TasksUpcomingRoute: TasksUpcomingRoute,
  TasksWaitingRoute: TasksWaitingRoute,
  AreasIndexRoute: AreasIndexRoute,
  FinanceIndexRoute: FinanceIndexRoute,
  HealthIndexRoute: HealthIndexRoute,
  PeopleIndexRoute: PeopleIndexRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
  TasksIndexRoute: TasksIndexRoute,
  TasksAreasIdRoute: TasksAreasIdRoute,
  TasksItemIdRoute: TasksItemIdRoute,
  TasksPeopleIdRoute: TasksPeopleIdRoute,
  TasksProjectsIdRoute: TasksProjectsIdRoute,
  TasksAreasIndexRoute: TasksAreasIndexRoute,
  TasksPeopleIndexRoute: TasksPeopleIndexRoute,
  TasksProjectsIndexRoute: TasksProjectsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
